import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import { ConfigurationProfile, DeviceVersion, IdResponse, SchemaField, SuccessResponse } from '@/types';

export class DeviceTypeService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getSystemDeviceTypes(): Promise<DeviceVersion[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisationId}/deviceVersions`);
  }

  public async getSystemDeviceType(deviceTypeId: number): Promise<DeviceVersion> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisationId}/deviceVersions/${deviceTypeId}`);
  }

  public async getCatalogueDeviceType(deviceTypeId: number): Promise<DeviceVersion> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisationId}/catalogue/${deviceTypeId}`);
  }

  public async getCatalogue(): Promise<DeviceVersion[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisation}/catalogue`);
  }

  public async addToCatalogue(versionIds: number[]): Promise<DeviceVersion[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    const payload: any = {versionIds};
    return this.api.post(`organisation/${organisationId}/catalogue/bulk`, payload);
  }

  public async removeFromCatalogue(versionId: number): Promise<SuccessResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.delete(`organisation/${organisationId}/catalogue/${versionId}`);
  }

  public async getConfigurationProfiles(versionId: number): Promise<ConfigurationProfile[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisationId}/deviceVersions/${versionId}/configurationProfiles`);
  }

  public async createOrganisationConfigurationProfile(versionId: number, profile: object): Promise<ConfigurationProfile> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.post(`organisation/${organisationId}/deviceVersions/${versionId}/configurationProfiles`, profile);
  }

  public async updateOrganisationConfigurationProfile(versionId: number, profileId: number, profile: ConfigurationProfile): Promise<IdResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.put(`organisation/${organisationId}/deviceVersions/${versionId}/configurationProfiles/${profileId}`, profile);
  }

  public async updateNetmoreConfiguration(versionId: number, netmoreConfiguration: string): Promise<IdResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.put(`organisation/${organisationId}/catalogue/deviceVersions/${versionId}`, { netmore_configuration: netmoreConfiguration });
  }

  public async deleteOrganisationConfigurationProfile(versionId: number, profileId: number): Promise<SuccessResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.delete(`organisation/${organisationId}/deviceVersions/${versionId}/configurationProfiles/${profileId}`);
  }

  public async getConfigurationsForMultipleDeviceVersions(deviceVersionIds: number[]): Promise<ConfigurationProfile[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    const queryString = deviceVersionIds.reduce((qs, id) => {
      if (qs === '') {
        return `deviceVersionIds=[${id.toString()}`;
      } else {
        return `${qs},${id.toString()}`;
      }
    }, '') + ']';
    return this.api.get(`organisation/${organisationId}/deviceVersions/configurationProfiles?${queryString}`);
  }

  public async getSchemas(versionId: number): Promise<SchemaField[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisationId}/deviceVersions/${versionId}/schemas`);
  }
}

export default new DeviceTypeService();
